// Campo libre y opcional para explicar por qué se cancela/anula una factura.
// El backend lo guarda en la factura (columna razonanula) y en la bitácora;
// vacío no bloquea la cancelación.
import TextField from "@mui/material/TextField";
import PropTypes from "prop-types";
import { fpMultilineInputSx } from "./inputStyles";

export const LARGO_RAZON_CANCELACION = 250;

export default function RazonCancelacionField({ value, onChange, disabled }) {
  return (
    <TextField
      fullWidth
      multiline
      minRows={2}
      label="Razón de la cancelación (opcional)"
      value={value}
      onChange={(e) => onChange(e.target.value.slice(0, LARGO_RAZON_CANCELACION))}
      disabled={disabled}
      helperText={`${value.length}/${LARGO_RAZON_CANCELACION}`}
      sx={{ ...fpMultilineInputSx, mt: 2 }}
    />
  );
}

RazonCancelacionField.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

RazonCancelacionField.defaultProps = {
  disabled: false,
};
